<template>
    <div class="ui-select-deal">
        <ui-overlay-load v-if="load" />

        <div class="ui-no-content" v-if="!optionsComputed.length">
            <div class="title">Nenhum item foi encontrado.</div>
        </div>
        
        <template v-else>
            <div class="info">
                Encontramos <span class="color">{{ optionsComputed.length }}</span> negócios para <span class="color">{{ client.name }}</span>
            </div>
    
            <div class="items-wrapper">
                <div class="items-scroller">
                    <div class="items">
                        <div class="item"
                            v-for="option of optionsComputed"
                            :key="option.id"
                            :class="{'current': option == selected}"
                            @click="select(option)">
                            <ui-deal-card :data="option" />
                            <i class="fal fa-check"></i>
                        </div>

                        <div class="item add-new" :class="{'current': newDeal == selected}" @click="select(newDeal)">
                            <strong>Criar novo negócio</strong>
                            <i class="fal fa-check"></i>
                        </div>
                    </div>
                </div>
            </div>
        </template>

    </div>
</template>

<script>
    import uiDealCard from "../deal-card"
    import { uiOverlayLoad } from '@/components/ui'

    export default {
        components: {
            uiDealCard,
            uiOverlayLoad,
        },

        props: {
            value: {
                type: Array,
                required: false,
                default () {
                    return []
                }
            },

            default: {
                type: Number,
                required: false,
            },

            load: {
                type: Boolean,
                required: false,
            }, 

            client: {
                type: Object,
                required: true,
                default () {
                    return {}
                }
            }, 
        },

        data() {
            return {
                selected: null,
                newDeal: {
                    id: 'newDeal',
                }
            }
        },

        created: async function () {
            await this.$nextTick(() => {
                if (this.default && this.optionsComputed) {
                    this.selected = this.optionsComputed.find(option => option.id === this.default)
                    this.$emit("input", this.selected)
                }
            })
        },

        computed: {
            optionsComputed() {
                return this.value
            },

            selectedComputed: {
                get() {
                    return this.default ? this.optionsComputed[this.default] : this.selected
                },
                set(value) {
                    if(value) {
                        this.selected = value
                        this.$emit('input', value)
                    }
                }
            },
        },

        methods: {
            select(option) {
                if (this.selectedComputed !== option) {
                    this.selectedComputed = option
                }
            },
        },

        watch: {
            value: function (newValue, oldValue) {
                if(newValue !== oldValue) {
                    this.selected = null
                    this.selectedComputed = null
                }
            }
        },
    }
</script>

<style lang="stylus" scoped>
    @import './styles.styl'
</style>